import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=588e83bf&scoped=true&"
import script from "./ui-select.vue?vue&type=script&lang=js&"
export * from "./ui-select.vue?vue&type=script&lang=js&"
import style0 from "./ui-select.vue?vue&type=style&index=0&id=588e83bf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e83bf",
  null
  
)

export default component.exports